import { jsxs as l, jsx as e } from "react/jsx-runtime";
import '../../assets/Alert.css';function m({
  variant: r,
  style: s,
  title: c,
  Icon: a,
  children: t,
  className: i = "",
  ...n
}) {
  return /* @__PURE__ */ l(
    "div",
    {
      className: `alert alert--${r} ${i}`,
      style: s,
      ...n,
      children: [
        a && /* @__PURE__ */ e("span", { className: "alert-circleIcon", children: /* @__PURE__ */ e("span", { className: "alert-icon", children: a }) }),
        /* @__PURE__ */ l("div", { className: "alert-body", children: [
          /* @__PURE__ */ e("b", { className: "alert-title", children: c }),
          /* @__PURE__ */ e("div", { className: "alert-message", children: t })
        ] })
      ]
    }
  );
}
export {
  m as Alert
};
//# sourceMappingURL=Alert.js.map
